import { Button } from "@mui/material";
import { useContext, useEffect } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomTooltip from "../../../../components/CustomTooltip";
import SpinningIcon from "../../../../components/SpinningIcon";
import { Toast } from "../../../../components/Toast";
import { NotificationContext } from "../../../../contexts/NotificationContext";

const BuildGRCUser = ({ loadingMessage, setLoading, ...props }) => {
  const { isLoading, setIsLoading, setIsScanning, setTaskId } =
    useContext(NotificationContext);
  const colors = useColors();
  const collectMessage = "Collecting in the background...";
  const { runBuildGRCUser } = useAPI();

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);

  const requestCollection = () => {
    setIsLoading(true);
    runBuildGRCUser().then((result) => {
      setIsScanning(true);
      Toast.info(collectMessage);
      setTaskId(result.data);
    });
  };

  return (
    <>
      <CustomTooltip title={isLoading ? loadingMessage : ""}>
        <span>
          <Button
            sx={{
              background: colors.grey_50,
              color: colors.contrast_text_dark,
              height: "32px",
              marginLeft: "5px",
              border: "1px solid",
              borderRadius: "8px",
            }}
            startIcon={<SpinningIcon isLoading={isLoading} />}
            onClick={requestCollection}
            disabled={isLoading}
            {...props}
            style={{ textTransform: "none" }}
          >
            {isLoading ? "Building GRC Users..." : `Build GRC Users`}
          </Button>
        </span>
      </CustomTooltip>
    </>
  );
};

export default BuildGRCUser;
